import { queryOptions } from '@tanstack/react-query'

import { listMappingCandidates } from './api'

export const mappingCandidatesQueryKeys = {
  all: ['admin-mapping-candidates'] as const,
  list: (filter: {
    status: 'pending' | 'dismissed' | 'approved'
    page: number
    pageSize: number
    minScore?: number
    competitionCode?: string
    season?: number
  }) => [...mappingCandidatesQueryKeys.all, 'list', filter] as const,
}

export function mappingCandidatesListQueryOptions(filter: {
  status: 'pending' | 'dismissed' | 'approved'
  page: number
  pageSize: number
  minScore?: number
  competitionCode?: string
  season?: number
}) {
  return queryOptions({
    queryKey: mappingCandidatesQueryKeys.list(filter),
    queryFn: () => listMappingCandidates(filter),
    staleTime: 5000, // 5 seconds staleTime
  })
}
